import axios from "axios";
import {setStorage,getStorage,getAuthHeader} from '../config/Utils'
import { encode, base64 } from "base-64";



export const getMasterCardUrl= async(body)=>{
  const url=`https://www.allenoverseas.com/mastercard/payment_getway.php`
  return await axios.post(url, body,
    {
      auth: {
        username: 'AllenOverseas-pauGatway', 
        password: 'MWM0pPEgTnC8SuO9krAUFJ1M#q@ImY'
      },
      headers: {
        "Content-Type": "application/json"
      }
    },getAuthHeader()
    ).then((res)=>{
    return res.data
  })
}


// export const getMasterCardUrl= async(body)=>{
// axios({
//   method: 'post',
//   url: 'https://www.allenoverseas.com/mastercard/payment_getway.php', 
//   auth: {
//     Username: 'AllenOverseas-pauGatway',
//     Password: 'MWM0pPEgTnC8SuO9krAUFJ1M#q@ImY'
//   },
//   headers : {
//     "Content-Type": "application/json"
//   }
// }
//  ).then((res)=>{
//       console.log('res body....',body)
//       return res.data
//       console.log('res body.',body)
//     })
// }
 

// export const sendMastercardPayInfo=async(body)=>{
//   const url=`http://127.0.0.1/registration_admin_23_24/api/mastercardstoreinfo`
//   return axios.post(url,body,getAuthHeader()).then((res)=>{
//       return res.data 
//   })
// }